// src/context/ToastContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';
import '../styles/Toast.css';

const ToastContext = createContext(null);

const DEFAULTS = {
  success: 2500,
  error:   5000,
  info:    3000,
};

const ICONS = {
  success: '✓',
  error:   '⚠',
  info:    'ℹ',
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const push = useCallback((type, message, duration) => {
    const id = Date.now() + Math.random();
    const life = duration ?? DEFAULTS[type] ?? 3000;
    setToasts(prev => [...prev, { id, type, message }]);
    setTimeout(() => dismiss(id), life);
    return id;
  }, [dismiss]);

  const api = {
    success: (msg, ms) => push('success', msg, ms),
    error:   (msg, ms) => push('error',   msg, ms),
    info:    (msg, ms) => push('info',    msg, ms),
    dismiss,
  };

  return (
    <ToastContext.Provider value={api}>
      {children}
      <div className="toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast toast--${t.type}`}>
            <span className="toast-icon">{ICONS[t.type]}</span>
            <span className="toast-message">{t.message}</span>
            <button className="toast-close" onClick={() => dismiss(t.id)} aria-label="Dismiss">✕</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within a ToastProvider');
  return ctx;
}
